// frontend/src/store.js - Updated without coupon reducer

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { thunk } from 'redux-thunk';
import authReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice';
import orderReducer from './slices/orderSlice';
import adminReducer from './slices/adminSlice';
import deliveryStaffReducer from './slices/deliveryStaffSlice';
import productsReducer from "./slices/productsSlice";
import productReducer from "./slices/productSlice";
import featuredProductsReducer from "./slices/featuredProductsSlice";

// Only set initial state from localStorage if it exists
const deliveryStaffInfo = localStorage.getItem('deliveryStaffInfo')
    ? JSON.parse(localStorage.getItem('deliveryStaffInfo'))
    : null;

const initialState = {
    deliveryStaffState: {
        loading: false,
        isAuthenticated: !!deliveryStaffInfo,
        deliveryStaff: deliveryStaffInfo ? deliveryStaffInfo.deliveryStaff : null,
        error: null
    }
};

const reducer = combineReducers({
    productsState: productsReducer,
    productState: productReducer,
    featuredProductsState: featuredProductsReducer,
    authState: authReducer,
    cartState: cartReducer,
    orderState: orderReducer,
    adminState: adminReducer,
    deliveryStaffState: deliveryStaffReducer
    // Removed couponState: couponReducer
});

const store = configureStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk)
});

export default store;